module.exports = __webpack_public_path__ + "img/feature-icon-4.be72a1c0.svg";